import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

export const TOKEN_KEY = "db_token";

export function setToken(token) {
  if (token) localStorage.setItem(TOKEN_KEY, token);
  else localStorage.removeItem(TOKEN_KEY);
}
export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}

api.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

// Teardown guard: while a logout/session-teardown is in progress, expected auth
// failures (401/403) from background/in-flight requests are NOT real errors. We
// resolve them to a benign empty response so they can never surface as an
// unhandled promise rejection or an error overlay. This is scoped strictly to the
// logout window — it does NOT suppress 401/403 globally during normal usage.
let loggingOut = false;
export function setLoggingOut(v) { loggingOut = v; }
export function isLoggingOut() { return loggingOut; }

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    if (loggingOut && (status === 401 || status === 403)) {
      return Promise.resolve({ data: {}, status, __sessionEnded: true });
    }
    return Promise.reject(error);
  }
);

export function photoUrl(photoId) {
  if (!photoId) return null;
  const t = getToken();
  return `${API}/photos/${photoId}/raw${t ? `?auth=${encodeURIComponent(t)}` : ""}`;
}

export function wsUrl() {
  const t = getToken();
  const base = BACKEND_URL.replace(/^http/, "ws");
  return `${base}/api/ws?token=${encodeURIComponent(t || "")}`;
}

export default api;
